import { CropConstants } from './constants/Crop';
import { isBulgaria } from './countryCode';

export const updatePhoneNumberBasedOnCountry = (phone: string | undefined, country: string) => {
  const cleanPhone = (phone ?? '').replace('+', '');
  if (cleanPhone && isBulgaria(country.trim())) {
    return `+${cleanPhone}`;
  }
  if (country.toLowerCase().replace(/\s+/g, '') === CropConstants.SERBIA.toLowerCase()) {
    return `+${cleanPhone}`;
  } else {
    return cleanPhone;
  }
};
